import angular from "angular";

angular
    .module('app')
    .component('usersOnline', {
        template: require('./users-online.html'),
        controller: ['$timeout', controller],
        bindings: {}
    });

function controller ($timeout) {
    let $ctrl = this;

    $ctrl.onlineUsers = [];

    Echo.join('online')
        .here(function (users) {
            $timeout(function () {
                $ctrl.onlineUsers = users;
            });
        })
        .joining(function (user) {
            $timeout(function () {
                $ctrl.onlineUsers.push(user);
            });
        })
        .leaving(function (user) {
            $timeout(function () {
                $ctrl.onlineUsers = $ctrl.onlineUsers.filter(function (us) {
                    return us.id !== user.id;
                });
            });
        });
}
